import Vue from 'vue' ;
import { Component, Watch }  from 'vue-property-decorator';
import { namespace }  from 'vuex-class' ;
import {
  PROFILE_MODULE_NAMESPACE,
  PROFILE_GET_MEMBERS,
  PROFILE_GET_ENTITY_ROLES,
  PROFILE_FILTER_CHANGE,
  PROFILE_SET_MEMBER_PARAMETER,
  PROFILE_RESET_MEMBERS,
  PROFILE_GET_ALL_ENTITY_ROLES,
  PROFILE_EDIT_MEMBER,
  PROFILE_ACTION,
  PROFILE_DELETE_MEMBER,
  PROFILE_SET_MEMBER_SELECTION,
  PROFILE_INIT_MEMBER_SELECTION,
  PROFILE_DELETE_MEMBERS,
  PROFILE_SET_PAGINATION_PAGE,
  PROFILE_LOADERS,
  PROFILE_SET_LOADER_STATE
} from '../../../store/profile/profile-types.store';
import { IMemberParameter } from '../../../models/profile/member.parameter';
import { CrudStatus, SearchEntities } from '../../../common/enums';
import { TranslateResult } from 'vue-i18n';
import { SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE } from '../../../store/search';
import { ProfileService } from '../../../services';

const ProfileStore= namespace(PROFILE_MODULE_NAMESPACE)
const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)

@Component({
  components: {
    'profile-filter-loader': async () => import('../loaders/profile-filter-loader/ProfileFilterLoader.vue'),
    'profile-table-loader': async () => import('../loaders/profile-pagination-loader/ProfilePaginationLoader.vue'),
    'profile-delete-loader': async () => import('../loaders/profile-delete-loader/ProfileDeleteLoader.vue')
  },
  filters: {
    acronym(value:string){
      if(!value) return
      const [firstname,lastname] = value.trim().split(' ')
      if(!lastname) return firstname.slice(0,2)
      return `${firstname[0]}${lastname[0]}`
    }
  }
})
class ProfileTeamManagement extends Vue {


    dtMembers: any[]

    dtIsLoading: boolean
    dtHoveredMember: number
    dtRolesFilters: any[]
    dtMessageErrorModel: boolean
    dtError: any

    readonly LOADING_TABLE: {}[] = Array.from(new Array(4)).map(item=> ({}))
    deleteDialog: boolean;
    confirmationDeleteMessage: TranslateResult;
    dtReplacementMembers : number
    replacementMembers: any;
    ProfileService:ProfileService
    roleIdToDelete: number;
    membreIdToDelete: number;
    loadingDelete: boolean;
    isMemberDeleted : boolean;
    pagination: any


    @Watch('$route.path')
    onProfilePathChange(newVal){
      const current_filter= this.$route.name === 'team-management' ?  'team' : 'external'
      this.storeSetMemberParameter({ current_filter, key: '' })
      this.setPageData(0)
    }

    constructor(){
        super()
        this.dtMembers= []
        this.dtIsLoading= false
        this.dtHoveredMember= -1
        this.dtMessageErrorModel= false
        this.dtError= null
        this.dtRolesFilters= []
        this.deleteDialog = false
        this.confirmationDeleteMessage = ''
        this.dtReplacementMembers = null
        this.replacementMembers = []
        this.ProfileService = new ProfileService()
        this.roleIdToDelete = null
        this.membreIdToDelete = null
        this.loadingDelete = false
        this.isMemberDeleted = false
        this.pagination = {
          page: 1,
          rowsPerPage: 10
        }
    }




    @ProfileStore.Action(PROFILE_GET_MEMBERS)
    storeGetMembers: (  payload : { $skip: number, $limit:number }) => Promise<any>

    /* @ProfileStore.Action(PROFILE_GET_ENTITY_ROLES)
    storeGetEntityRoles: (params: any) => Promise<any> */

    @ProfileStore.Action(PROFILE_GET_ALL_ENTITY_ROLES)
    storeGetAllEntityRoles: () => Promise<any>

    @ProfileStore.Action(PROFILE_FILTER_CHANGE)
    storeFilterChange: (filter: number[] ) => Promise<string>

    @ProfileStore.Action(PROFILE_EDIT_MEMBER)
    storeEditMember: (memberId?: number) => Promise<any>

    @ProfileStore.Action(PROFILE_RESET_MEMBERS)
    storeResetMembers: () => Promise<boolean>

    @ProfileStore.Action(PROFILE_DELETE_MEMBER)
    storeDeleteMember: () => Promise<any>

    @ProfileStore.Action(PROFILE_DELETE_MEMBERS)
    storeDeleteMembers: () => Promise<any>

    @ProfileStore.Mutation(PROFILE_ACTION)
    storeSetProfileAction: (action: CrudStatus) => void

    @ProfileStore.Mutation(PROFILE_SET_MEMBER_PARAMETER)
    storeSetMemberParameter: (payload: IMemberParameter ) => void

    @ProfileStore.Mutation(PROFILE_SET_MEMBER_SELECTION)
    storeSetMemberSelection: (memberId: number) => void

    @ProfileStore.Mutation(PROFILE_INIT_MEMBER_SELECTION)
    storeInitMemberSelection: () => void

    @ProfileStore.Mutation(PROFILE_SET_PAGINATION_PAGE)
    storeSetPaginationPage: (page: number) => void

    @ProfileStore.Mutation(PROFILE_SET_LOADER_STATE)
    storeSetLoaderState: (payload?: { key: any, value: boolean }) => void


    @ProfileStore.Getter members: Map<string,any[]>
    @ProfileStore.Getter totalPages: number
    @ProfileStore.Getter paginationTotal: number
    @ProfileStore.Getter paginationPage: number
    @ProfileStore.Getter totalItems: number

    @Watch('pagination',{deep:true})
    handlePagination(val:{page:number,rowsPerPage:number})
    {
      console.log('New pagination = ',val)
      this.dtIsLoading = true
        this.storeSetLoaderState({ key: PROFILE_LOADERS.MEMBERS_TABLE, value: true })
        this.storeGetMembers({ $skip: (val.page-1)*val.rowsPerPage, $limit:val.rowsPerPage })
        .then(response=>{
            this.coMembers = this.members.get(`${val.page}`)
            this.storeSetLoaderState({ key: PROFILE_LOADERS.MEMBERS_TABLE, value: false })
            this.dtIsLoading = false
        })

      //this.coMembers = this.members.get(`${val.page}`)
      /* if(!this.coMembers || !this.coMembers.length || this.coMembers === this.LOADING_TABLE ){
        this.dtIsLoading = true
        this.storeSetLoaderState({ key: PROFILE_LOADERS.MEMBERS_TABLE, value: true })
        this.storeGetMembers({ $skip: (val.page-1)*val.rowsPerPage, $limit:val.rowsPerPage })
        .then(response=>{
            this.coMembers = this.members.get(`${val.page}`)
            this.storeSetLoaderState({ key: PROFILE_LOADERS.MEMBERS_TABLE, value: false })
            this.dtIsLoading = false
        })
      }
      else this.storeSetLoaderState({ key: PROFILE_LOADERS.MEMBERS_TABLE, value: false }) */
    }

    @Watch("paginationPage")
    onPaginationPageChange(newVal: number){
      //console.log('Old pagination = ',newVal)
      /* if(newVal){
        this.coMembers = this.members.get(`${newVal}`)
        if(!this.coMembers || !this.coMembers.length || this.coMembers === this.LOADING_TABLE ){
          this.storeSetLoaderState({ key: PROFILE_LOADERS.MEMBERS_TABLE, value: true })
          this.storeGetMembers({ $skip: (newVal-1)*10 })
          .then(response=>{
              this.coMembers = this.members.get(`${newVal}`)
              this.storeSetLoaderState({ key: PROFILE_LOADERS.MEMBERS_TABLE, value: false })
          })
        }
        else this.storeSetLoaderState({ key: PROFILE_LOADERS.MEMBERS_TABLE, value: false })

      }
      else this.storeSetPaginationPage(1) */
    }

    @ProfileStore.Getter internalEntityRoles: any[]
    @ProfileStore.Getter externalEntityRoles: any[]
    @ProfileStore.Getter currentFilter: string
    @ProfileStore.Getter profileCrudActionStatus: CrudStatus
    @ProfileStore.Getter memberSelection: number[]
    @ProfileStore.Getter loaders: Map<string,boolean>
    @ProfileStore.Getter memberParameter: IMemberParameter
    @Watch("memberParameter")
    onMemberParamterChange(newValue: IMemberParameter ){
      console.log('onMemberParamterChange', newValue)
      this.storeResetMembers()
      .then((value)=>{
        this.handlePagination({page:1,rowsPerPage:10})
        this.storeSetPaginationPage(0)
      })
    }

    created() {
      //console.log("member parameter=",this.memberParameter)
    }

    async mounted() {
      this.storeSetLoaderState({ key: [PROFILE_LOADERS.MEMBERS_FILTERS, PROFILE_LOADERS.MEMBERS_TABLE] , value: true })
      await this.storeGetAllEntityRoles()
          .then(()=>{
            this.storeSetMemberParameter({ current_filter: 'team' })
            if(this.$route.name === 'other-users')
                this.storeSetMemberParameter({ current_filter: 'external' })
            this.setPageData(1)
          })
          .catch(err=> console.log('error getting entity roles') )
    }

    beforeDestroy() {
      this.storeSetPaginationPage(0)
    }



    get lblSetting(){
        return {
            ...require('@/locales/profile').default,
            ...require('@/locales/button').default
        }
    }

    get coFiltersLoader(): boolean {
      return this.loaders.get(PROFILE_LOADERS.MEMBERS_FILTERS)
    }

    get coTableLoader(): boolean {
      return this.loaders.get(PROFILE_LOADERS.MEMBERS_TABLE)
    }

    get role(): number[] {
      return this.$route.name === 'team-management' ? this.memberParameter.team_roles: this.memberParameter.external_roles
    }

    set role(value: number[]){
      //const current_filter= value && value.length ? 'role' :
        //                                      this.$route.name === 'team-management' ? 'team' : 'external'
      let roles= {}
      if(this.$route.name === 'team-management') roles= { team_roles: value }
      else roles= { external_roles: value }

      this.storeSetMemberParameter({ ...roles  , key: '' })
    }

    get coHeaders(): any[] {
        return [
          {
            //text: 'avatar',
            value: 'avatar',
            align: 'left',
            sortable: false,
            class: 'primary--text dr-table__title'
          },
          {
            text: this.$t(this.lblSetting.members_headers.fullname),
            align: 'left',
            sortable: false,
            class: 'primary--text dr-table__title'
          },
          {
            text: this.$t(this.lblSetting.members_headers.email),
            align: 'left',
            sortable: false,
            class: 'primary--text dr-table__title'
          },
          {
            text: this.$t(this.lblSetting.members_headers.tel_fix),
            align: 'left',
            sortable: false,
            class: 'primary--text dr-table__title'
          },
          {
            text: this.$t(this.lblSetting.members_headers.tel_portable),
            align: 'left',
            sortable: false,
            class: 'primary--text dr-table__title'
          },
          {
            value: 'modifier & supprimer',
            align: 'left',
            sortable: false,
            class: 'primary--text dr-table__title hidden'
          }
        ]
    }

    get coMembers(): any[] {
      return !this.coTableLoader ? this.dtMembers : this.LOADING_TABLE
    }

    set coMembers(value:any[]) {
      this.dtMembers= value
    }

    get coTotalPages(): number {
      return this.paginationTotal
    }

    get coCurrentPage(): number {
      return this.paginationPage
    }

    set coCurrentPage(value: number){
      this.storeSetPaginationPage(value)
    }

    get coFilter(): { entity?: string, role?: string, key?: string } {
      const { current_filter } = this.memberParameter
      return current_filter === 'key' ?
                      { key: this.memberParameter.key  } :
                            current_filter === 'team' ?
                                  { entity: 'team' } : { role: this.memberParameter.role.join() }
    }

    get coDelectionMemberName(): string {
      if(this.memberSelection.length){
        const member: any = this.members.get(`${this.paginationPage}`).find( member => member.id === this.memberSelection[0] )
        return member.name
      }

      return ""
    }

    get coProfileDelectionMessage(): TranslateResult {
      if(this.memberSelection.length === 1) return this.$t(this.lblSetting.profileDeleteMessage,{ fullname: this.coDelectionMemberName })
      else if(this.memberSelection.length > 1) return this.$t(this.lblSetting.profileDeleteSelectionMessage)
      return ""
    }

    get isOpenDeleteMessage(): boolean {
      return this.profileCrudActionStatus === CrudStatus.Delete
    }

    displayEditMember (member) {
      if (!this.$route.meta['edit_team_account']) return false
      if (this.$route.meta['manage_customer_account']) return true
      return member.role_id !== 5 && member.role_id !== 1;
    }
    displayEditExternalMember (member) {
      if (this.$route.meta['manage_external_account'] && member.role_id === 19) return true
    }

    isMemberSelected(id: number) : boolean {
      return this.memberSelection.indexOf(id) !== -1
    }

    getMemberById(id: number): Promise<any> {
      return Promise.resolve(this.coMembers.find( member => member.id === id ))
    }

    setPageData(page: number){
      this.storeSetPaginationPage(page)
      this.setFilterItems()
    }

    setFilterItems() {
      if( this.$route.name === 'team-management' ) this.dtRolesFilters= this.internalEntityRoles
      if( this.$route.name === 'other-users' ) this.dtRolesFilters= this.externalEntityRoles
      this.storeSetLoaderState({ key: PROFILE_LOADERS.MEMBERS_FILTERS, value: false })
    }


    handleEditMember(id: number){
      this.storeEditMember(id)
        .catch(err=>{
          this.dtMessageErrorModel= true
          this.dtError= err
        })
    }

    handleDeleteMember(id: number){
      this.storeInitMemberSelection()
      this.storeSetMemberSelection(id)
      this.storeSetProfileAction(CrudStatus.Delete)
    }

    async handleDeleteMembre2(member: {id:number,role_id:number, fullname:string})
    {
      this.roleIdToDelete = null
      this.membreIdToDelete = null
      this.confirmationDeleteMessage = null
      this.dtReplacementMembers = null
      this.replacementMembers = null
      //console.log(member)
      this.confirmationDeleteMessage = this.$t(this.lblSetting.profileDeleteMessage,{ fullname: member.fullname })
      this.roleIdToDelete = member.role_id
      this.membreIdToDelete = member.id

      const remplacementMemebers =  await this.ProfileService.getReplacementMembers({
        role:[this.roleIdToDelete],
        //entity:'team',
        $skip:0,
        $limit:50
      })

      console.log(remplacementMemebers)
      this.replacementMembers = remplacementMemebers.data.filter(item=>item.id!==member.id)
      this.deleteDialog = true
    }

    deleteAndReplaceMembre()
    {
      // /account/:id?replace_user=true&replacement_id=:replacement_id
      //console.log(`/account/${this.membreIdToDelete}?replace_user=true&replacement_id=${this.dtReplacementMembers}`)
      this.loadingDelete = true
      /* this.isMemberDeleted = true
      this.loadingDelete = false */
      this.ProfileService.deleteAndReplaceMember(this.membreIdToDelete, this.dtReplacementMembers).then(response=>{
        this.isMemberDeleted = true
        this.loadingDelete = false
      }).finally(()=>{
        this.isMemberDeleted = true
        this.loadingDelete = false
      })
    }

    handleCancelDeleteMemebre()
    {
      this.deleteDialog = false
      this.roleIdToDelete = null
      this.membreIdToDelete = null
      this.confirmationDeleteMessage = null
      this.dtReplacementMembers = null
      this.replacementMembers = null
      this.isMemberDeleted = false
    }

    async searchReplacementMembers()
    {
      return []
    }

    handleDeleteCancel(){
      this.storeInitMemberSelection()
      this.storeSetProfileAction(CrudStatus.NoAction)
    }

    handleDeleteOK(){
      this.dtIsLoading= true
      this.storeDeleteMember()
      .then(()=>{
        this.storeInitMemberSelection()
      })
      .catch(err=>{
        this.dtMessageErrorModel= true
        this.dtError= err
      })
      .finally(()=> this.dtIsLoading= false )
    }

    handleAvatarClick(id: number){
      this.storeSetMemberSelection(id)
    }

    handleDeleteSelection(){
      if(this.memberSelection.length) this.storeSetProfileAction(CrudStatus.Delete)
    }

    handleDeleteSelectionCancel(){
      this.storeInitMemberSelection()
      this.storeSetProfileAction(CrudStatus.NoAction)
    }

    handleDeleteSelectionOK(){
      this.dtIsLoading= true
      this.storeDeleteMembers()
      .then(deletedMembers=>{
        this.storeInitMemberSelection()
      })
      .catch(err=>{
         this.dtMessageErrorModel= true
         this.dtError= err
      })
      .finally(()=> this.dtIsLoading= false )
    }

    handleCloseErrorModal(){
      this.dtError= null
      this.dtMessageErrorModel= false
    }

}

export default ProfileTeamManagement



// WEBPACK FOOTER //
// ./src/containers/profile/team-management/index.ts